import {AbstractEvent} from "@/modules/base/events";
import {TransferOffer} from "@/modules/transfer-market/entity";

export class BeforeTransferClosedEvent extends AbstractEvent {
  constructor(
    public offer: TransferOffer,
  ) {
    super();
  }
}